/**
 * @module AuthConsumer
 * @summary Exports AuthConsumer component
 */

import { Consumer } from '../context'

export default Consumer
